import { AccountStatementContext } from "@state/context/account-statement/AccountStatementContext";
import AccountStatementStore from "@state/stores/account-statement/AccountStatementStore";
import { useContext } from "react";

export function useAccountStatementStore(): AccountStatementStore {
	const accountStatementStore = useContext(AccountStatementContext);

	if (accountStatementStore == null) {
		throw new Error(
			"useAccountStatementStore must be used within an AccountStatementContext. Make sure the component is wrapped in <AccountStatementProvider>."
		);
	}
	return accountStatementStore;
}
